<template>
  <div class="checks-item">
    <div class="header-title">
      {{ __(item.HeaderTitle) }}
    </div>
    <div class="middle">
      <div class="amount">
        <span class="label">{{ __('Total amount') }}:</span>
        <span class="value">{{ item.Amount }}</span>
      </div>
      <div class="numbers-of-payments">
        <span class="label">{{ __('Numbers of payments') }}:</span>
        <span class="value">{{ item.NumbersOfPayments }}</span>
      </div>
      <div class="first-check-day">
        <span class="label">{{ __('First check date') }}:</span>
        <span class="value date">{{
          localFormatDate(item.checks[0].DepositDate)
        }}</span>
      </div>
    </div>
    <div class="action">
      <i class="pi pi-arrow-left"></i>
      <span class="label" @click="addChecks()">{{
        __('Go to add checks')
      }}</span>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/services/apointUtil'
export default {
  name: 'ChecksItem',
  props: ['item'],
  emits: ['addChecks'],
  methods: {
    localFormatDate(date) {
      return formatDate(date)
    },
    addChecks() {
      this.$emit('addChecks', this.item)
    },
  },
}
</script>

<style scoped>
.checks-page-container {
  padding: 20px;
}

.checks-table {
  width: 100%;
  margin-bottom: 20px;
}

.checks-table .p-vue-column {
  text-align: left;
}

.date-container {
  display: flex;
  align-items: center;
}

.date-container span {
  margin-right: 10px;
}

.checks-actions .p-button {
  margin-right: 10px;
}
.layout {
  display: flex;
  height: 164px;
  padding: 23px 6px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid rgba(206, 204, 204, 0.93);
  background: #fff;
  box-shadow: 0px 2px 8px 0px rgba(85, 80, 80, 0.15);
  flex-direction: column;
}
.layout .header-title {
  color: #000;
  text-align: start;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-self: stretch;
  width: 100%;
}
.layout .middle {
  display: flex;
  flex-direction: row;
  height: 69px;
  align-items: flex-start;
  gap: 26px;
  width: 100%;
}

.middle .amount {
  width: 22%;
}
.middle .numbers-of-payments {
  width: 39%;
}
.middle .first-check-day {
  width: 39%;
}
.middle .lable {
  color: #484f61;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.middle .value {
  color: #373c49;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.action {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  color: var(--Green-buildup, #469609);
}
.action .lable {
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 5px;
}
.action .icon {
  margin: 5px;
}
</style>
